import { Button, StepperFooter } from '@folio/components';
import type { UseFormReturn } from 'react-hook-form';
import { Group } from '@folio/components/ui/flex';

interface FormBuilderFooterProps {
  mode: 'standalone' | 'stepper';
  onSubmit: () => void;
  form: UseFormReturn<Record<string, unknown>>;
  showPreviousButton: boolean;
  showNextButton?: boolean;
  nextButtonEnabled?: boolean;
}

export function FormBuilderFooter({
  mode,
  onSubmit,
  form,
  showPreviousButton,
  showNextButton = true,
  nextButtonEnabled = true,
}: FormBuilderFooterProps) {
  if (mode === 'standalone') {
    return (
      <Group align="stretch" justify="end">
        <Button onClick={onSubmit}>Enregistrer</Button>
      </Group>
    );
  }

  return (
    <StepperFooter
      nextButtonEnabled={showNextButton && nextButtonEnabled}
      showNextButton={showNextButton}
      showPreviousButton={showPreviousButton}
      loading={form.formState.isSubmitting}
      onNext={onSubmit}
    />
  );
}
